export const GetCurrentSubscriptionCode = (activeTab, trialData, payluxData, keyData) => {
  let subscriptionCode = '';
  switch (activeTab) {
    case 'key':
      subscriptionCode = keyData?.SubscriptionCode;
      break;
    case 'paylux':
      subscriptionCode = payluxData?.SubscriptionCode;
      break;
    case 'trial':
      subscriptionCode = trialData?.SubscriptionCode;
      break;
    default:
      break;
  }

  return subscriptionCode;
};
